module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog-base', {
    ref: "base"
  }, [_c("template", {
    tag: "div",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("データをダウンロード中です")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "my-lead"
  }, [_vm._v("画面を閉じずに、そのままお待ちください")]), _vm._v(" "), _c('dn-progress-bar', {
    staticClass: "my-progress",
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e81af6d8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/DialogDownload.vue
// module id = 443
// module chunks = 1